module.exports = __webpack_public_path__ + "media/images/cbjj/book-e6c001eec140738c0f9c079c35be207c.jpg";